import React from "react";
import "./LoadingSpinner.css";

interface LoadingSpinnerProps {
  isLoading: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="loading-balls">
          <div className="ball ball-1"></div>
          <div className="ball ball-2"></div>
        </div>
        <p className="loading-text">Cargando...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
